module.exports = __webpack_public_path__ + "static/media/solicitante.b4e61e77.png";